import React, {Component,PropTypes} from 'react'
import {Link} from 'react-router'
import Config, { userDetails } from   '../config/app';
var request = require('superagent');
import NavBar from '../components/NavBar'
import firebase from '../config/database'
import Indicator from '../components/Indicator'


import * as firebaseREF from 'firebase';
require("firebase/firestore");

var stringtopic = "";
var idclinicapush;



class App extends Component {


   

	constructor(props) {
        super(props);
   

        this.state = {value: props.value,status:'',link_image:'',type:'',title:'',message:'',clinica:'',theKey:'',isLoading:false,longMessage:''};

	    this.handleChange = this.handleChange.bind(this);
        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleChangeType = this.handleChangeType.bind(this);
        this.handleChangeLongMessage=this.handleChangeLongMessage.bind(this);
	    this.handleSubmitFirebase = this.handleSubmitFirebase.bind(this);
        this.handleSubmitOneSignal = this.handleSubmitOneSignal.bind(this);
        this.handleSubmitExpo = this.handleSubmitExpo.bind(this);
	    this.sendCallback = this.sendCallback.bind(this);
        this.displayTitle=this.displayTitle.bind(this);
        this.displaynotificationType=this.displaynotificationType.bind(this);
        this.displayLongMessage=this.displayLongMessage.bind(this);
     
        this.handleChangeimage=this.handleChangeimage.bind(this);
        this.submitImageToFirebase=this.submitImageToFirebase.bind(this);
        this.saveImageLinkInFirebase=this.saveImageLinkInFirebase.bind(this);
    
    
    
    }
     

	handleChange(event) {
		this.setState({message: event.target.value});
	}

    handleChangeTitle(event) {
        this.setState({title: event.target.value});
    }


    handleChangeType(event) {
        this.setState({type: event.target.value});
    }

    handleChangeLongMessage(event){
        this.setState({longMessage:event.target.value})
    }

	sendCallback(e,r){

        //After send, save notification in firestore
        if(Config.pushSettings.saveNotificationInFireStore){
             //Get reference to firestore
            var db = firebase.app.firestore();

            // Add a new document in collection "notifications"
            db.collection("notifications").doc((idclinicapush+new Date().getTime())).set({
                title: this.state.title,
                message: this.state.message,
                type : this.state.type,
                timestamp : new Date(),
                idclinica: idclinicapush,
                photo: this.state.link_image
            });



        }
		//console.log(r);
    	//console.log(e);
		this.setState({
            title:"",
            type:"",
            message:"",
            longMessage:"",
			status:": Enviado"
		})
	}



    



	handleSubmitFirebase(event) {
		//alert('A push was submitted: ' + this.state.value);
        event.preventDefault();

                    //     var body_info = "title :" + this.state.message + "," + "photo :" + this.state.link_image;
        /*  
                         var body_info = {
                               "title": this.state.message,
                               "photo": this.state.link_image
                         };
                        var myJSONString = JSON.stringify(body_info);
          */              

              //  console.log(stringtopic);
                var url='https://fcm.googleapis.com/fcm/send';
             //   var json = '{"to":"'+Config.pushSettings.pushTopic+'","notification": {"body":"'+this.state.value+'",},"priority":10,}';
          //      var json = '{"to":"'+stringtopic+'","notification": {"title":"'+this.state.title+'","body": {"title":"'+this.state.message+'","photo":"'+this.state.link_image'"},},"priority":10,}';
           //     var json = '{"to":"'+stringtopic+'","notification": {"title":"'+this.state.title+'","body":"'+myJSONString+'",},"priority":10,}';



     


                var body_info = {
                    
                    "to" : stringtopic,
                    "notification": {

                        "title" : this.state.title,
                        "body" : this.state.message,

                    },

                    "data": {
                            "tipo" : 'fireadmin_notification',
                            "title" : this.state.title,
                            "type" : this.state.type,
                            "message" : this.state.message,
                            "photo": this.state.link_image,
                    },
                       
                    
                
                    "priority":10,

                } ;

                var json = JSON.stringify(body_info);
                console.log (json);
                
		        request.post(url)
    	        .set('Content-Type', 'application/json')
    	        .set('Authorization', 'key='+Config.pushSettings.Firebase_AuthorizationPushKey)
    	        .send(json)
                .end(this.sendCallback)

    
               
    }


    
   

    handleSubmitExpo(event){
        event.preventDefault();

        var title=this.state.title;
        var body=this.state.value;
        var type= this.state.type;
        var longMessage=this.state.longMessage;
        
        var _this=this;

        //Step 1 - get the tokens
        firebase.app.database().ref(Config.pushSettings.firebasePathToTokens).once('value').then(function(snapshot) {
            var tokens=snapshot.val();
            var notifications=[];

            
           
            Object.keys(tokens).forEach(function(key) {
                notifications.push({
                    to:tokens[key].token,
                    body: title,
                    title: body,
                    
                })
              });
             if(notifications.length>0){
                var url='https://cors-anywhere.herokuapp.com/https://exp.host/--/api/v2/push/send';
                var json = JSON.stringify(notifications);
                request.post(url)
                    //.set('Accept-Encoding', 'gzip, deflate')
                    .set('Accept', 'application/json')
                    .set('Content-Type', 'application/json')
                    //.set('User-Agent', 'expo-server-sdk-node/2.3.3')
                    .send(json)
                    .end(_this.sendCallback)
             }else{
                 alert("There are no subscribed tokens");
             }

          });
    }

    handleSubmitOneSignal(event) {
        //alert('A push was submitted: ' + this.state.value);
        event.preventDefault();

        var url='https://onesignal.com/api/v1/notifications';
        var json = {
          "app_id":Config.pushSettings.oneSignal_APP_KEY,
          "included_segments":Config.pushSettings.included_segments,
          "headings":{"en": this.state.title},
          "contents":{"en": this.state.value}
        }

        request.post(url)
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Basic '+Config.pushSettings.oneSignal_REST_API_KEY)
            .send(json)
            .end(this.sendCallback)
    }

    displayTitle(){
        
                            return (<div className="form-group label-floating is-empty">
                                <label className="control-label">Título del Mensaje</label>
                                <input type="text" className="form-control" value={this.state.title} onChange={this.handleChangeTitle} />
                            <span className="material-input"></span></div>)
    }


    displaynotificationType(){

        return (

            <div className="form-group label-floating is-empty">
            <label className="control-label"></label>
              <select className="form-control" value={this.state.type} onChange={this.handleChangeType}>
             
                         <option value="novetat">Novedad</option>
                         <option value="avis">Aviso</option>
                         <option value="promocio">Promoción</option>
                         <option value="recordatori">Recordatorio</option>

                    </select>
            </div>



        )




    }


    displayLongMessage(){
        if(Config.pushSettings.pushType=="expo"){
                            return (<div className="form-group label-floating is-empty">
                                <label className="control-label">Message body</label>
                                <input type="text" className="form-control" value={this.state.longMessage} onChange={this.handleChangeLongMessage} />
                            <span className="material-input"></span></div>)}else{ return (<div></div>)}
    }



    getIdclinica(){


   
        var stringtopicinicial = stringtopic.search("/topics/"); 

        if (stringtopicinicial == -1){

          var user = firebase.app.auth().currentUser;


         // EXTRAER LA ID CLINICA PARA PASARLO COMO TOPIC 

             var database = firebase.app.firestore();

              database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {

                 Snapshot.forEach(function(docupdate) {

                     var usuariupdate = docupdate.data();

                     stringtopic = "/topics/" + usuariupdate.clinica; 
                     idclinicapush = usuariupdate.clinica;
                     console.log(stringtopic);

                });

             });

             

        }


    }


    
      saveImageLinkInFirebase(link){
        console.log(link);
        this.setState({link_image: link});
        this.setState({isLoading:false});
        this.props.updateAction(this.theKey,link);

      }
    
      submitImageToFirebase(value){
        var _this=this;
        // Create a root reference
        var storageRef = firebase.app.storage().ref('temporal/');
        var refFile=new Date().getTime()+".jpg"
    
        // Create a reference to 'mountains.jpg'
        var newImageRef = storageRef.child(refFile);
        var stripedImage=value.substring(value.indexOf('base64')+7, value.length);
    
        newImageRef.putString(stripedImage, 'base64').then(function(snapshot) {
          console.log('Uploaded a base64 string!');
          _this.saveImageLinkInFirebase(snapshot.downloadURL);
        });
      }


    handleChangeimage(e) {
        this.setState({isLoading:true});
         e.preventDefault();
        console.log("Start processing ....")
    
        let reader = new FileReader();
        let file = e.target.files[0];
    
        reader.onloadend = () => {
          console.log("Image is in base 64 now.. Upload it");
          this.setState({
            file: file,
            value: reader.result
          });
          this.submitImageToFirebase(reader.result)
    
        }
    
        reader.readAsDataURL(file)
    
      }


  render() {

    
       
   

    var imgSrc=this.state.value&&this.state.value.length>4?this.state.value:"../../assets/img/image_placeholder.jpg";

    return (
			<div className="content">
			<NavBar></NavBar>
           
      <div className="row">
      
      	<div className="col-md-6">
            <div className="card">
                <div className="card-header card-header-icon" data-background-color="rose">
                    <i className="material-icons">mail_outline</i>
                </div>
                <div className="card-content">
                    <h4 className="card-title">Enviar Mensajes a los usarios de la app  {this.state.status}</h4>
                    <form onSubmit={Config.pushSettings.pushType=="firebase"?this.handleSubmitFirebase:(Config.pushSettings.pushType=="expo"?this.handleSubmitExpo:this.handleSubmitOneSignal)}>
                        {this.displayTitle()}
                        <div className="form-group label-floating is-empty">
                            <label className="control-label">Mensaje</label>
                            <input type="text" className="form-control" value={this.state.message} onChange={this.handleChange} />
                        <span className="material-input"></span></div>
                        {this.getIdclinica()}
                        {this.displayLongMessage()}
                        {this.displaynotificationType()}
                       



                            <div className="fileinput fileinput-new text-center" data-provides="fileinputaa">
                             <div className="fileinput-new thumbnail">
                             <img src={imgSrc} alt="..." />
                             </div>
                            <div className="fileinput-preview fileinput-exists thumbnail"></div>
                            <div>
                            <span className="btn btn-rose btn-round btn-file">
                            <span className="fileinput-new">Upload image</span>
                            <span className="fileinput-exists">Change</span>
                            <input type="file" style={{width:'2000px'}} id={this.theKey} name={this.theKey}  onChange={this.handleChangeimage} />
                            </span>
                           <Indicator show={this.state.isLoading} />
                          <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
                          </div>
                         </div>


                        <button type="submit" className="btn btn-fill btn-rose">Enviar</button>
                    </form>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card">
                <div className="card-header card-header-icon" data-background-color="rose">
                    <i className="material-icons">smartphone</i>
                </div>
                <div className="card-content">
                    <h4 className="card-title">Preview</h4>
                    <div className="iphone">
                    	<img className="iphoneImg" src="iphone.png" alt="" />
      					<span className="pushText"><br /><br /><br /><br /><br /><br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.state.title} <br /><br />&nbsp;&nbsp;&nbsp;&nbsp; {Config.pushSettings.pushType=="firebase"?"":<br />} {this.state.message} </span>
                    </div>
                </div>
            </div>
        </div>
      </div>
			</div>
    )
  }
}
export default App;

Image.propTypes = {
    updateAction:PropTypes.func.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    class: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/containers/Push.js